export default {
  deleteSubject:"/corporate/deleteSubject",
  changeSubjectName:"/corporate/changeSubjectName",

};